import React from "react";
import { connect } from "react-redux";
import { signinActions } from "../actions";
import Modal from "./design/Modal.js";

import RedirectWhen from "./utils/RedirectWhen.js";

class ConnectedModal extends React.Component {
  state = {
    initial: {
      close: "closing",
      process: "processing"
    },
    processing: {
      process: "processing",
      close: "processing",
      success: "closing",
      fail: "initial"
    },
    closing: {
      close: "closed",
      onEntry: "finalizeClose"
    },
    closed: {
      close: "closed",
      onEntry: "notifyClosed"
    },
    current: "initial",
    success: false
  };

  componentDidMount() {
    this.props.notifyStore("openModal");
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.processing && !this.props.processing) {
      this.transition("process");
    } else if (!nextProps.processing && this.props.processing) {
      if (nextProps.success) {
        this.transition("success");
        this.setState({ success: true }); //add it to transition
      } else {
        this.transition("fail");
      }
    }
  }

  componentWillUnmount(nextProps, nextState) {
    this.notifyClosed();
  }

  currentState = () => this.state[this.state.current];

  transition = event => {
    const nextState = this.currentState()[event];
    if (nextState !== this.state.current) {
      const onEntry = this.state[nextState].onEntry;
      const onEntryFn = onEntry !== undefined ? this[onEntry] : () => false;
      this.setState(state => ({ current: nextState }), onEntryFn);
    }
  };

  closeModal = () => {
    this.transition("close");
  };

  finalizeClose = () => {
    this.noEffects()
      ? this.transition("close")
      : setTimeout(() => this.transition("close"), 320);
  };

  notifyClosed = () => {
    this.props.notifyStore("closeModal");
  };

  // ugly hack :p
  noEffects = () =>
    this.props.transitionTo &&
    this.state.success &&
    this.props.transitionTo.slice(-1) === "m";

  closingState = () =>
    this.noEffects() ? false : this.state.current === "closing";

  render = () => {
    const { notifyStore, transitionTo = "", children, ...rest } = this.props;
    const { current, success } = this.state;
    return (
      <RedirectWhen
        when={current === "closed"}
        to={success ? transitionTo : ""}
      >
        <Modal {...rest} close={this.closeModal} closing={this.closingState()}>
          {children}
        </Modal>
      </RedirectWhen>
    );
  };
}

const mapState = state => ({
  processing: state.processing
});

const mapDispatch = (dispatch, ownProps) => ({
  notifyStore: action => {
    dispatch(signinActions[action]());
  }
});

export default connect(mapState, mapDispatch)(ConnectedModal);
